"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.listAddOrUpdate = listAddOrUpdate;
exports.listRemove = listRemove;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function listAddOrUpdate(descriptor, list, bareItem, transform) {
    let hasSameId = descriptor.hasSameId;

    let count = 0;
    let res = list.map(item => {
        if (!hasSameId(item, bareItem)) {
            return item;
        }
        ++count;
        let updated = transform(item);
        return updated;
    });
    if (count === 0) {
        res.push(transform((0, _extends3.default)({}, bareItem)));
    }
    return res;
}
function listRemove(descriptor, list, bareItem) {
    return list.filter(item => !descriptor.hasSameId(item, bareItem));
}
//# sourceMappingURL=list.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/utils/list.js